<template>
  <template v-if="store.isPresential && store.loaded">
    <!-- Barra de progresso de perfil (quando há pendências) -->
    <div
      v-if="pendingCount > 0 && !dismissed.progress"
      class="bg-[#152a34] border-b border-[#0e1f27] text-white px-4 py-2.5 flex flex-wrap items-center justify-between gap-x-4 gap-y-2 text-sm"
    >
      <div class="flex items-center gap-3 flex-wrap flex-1 min-w-0">
        <span class="mdi mdi-account-clock text-lg flex-shrink-0 text-[#b99a52]"></span>
        <span class="flex-shrink-0">
          Perfil <strong>{{ completionPercent }}% completo</strong> —
          <span class="text-amber-300">você está perdendo agendamentos</span>
        </span>
        <!-- Barra de progresso -->
        <div class="flex-1 min-w-[120px] max-w-[200px] bg-white/20 rounded-full h-2">
          <div
            class="h-2 rounded-full transition-all duration-500"
            :class="completionPercent >= 100 ? 'bg-green-400' : completionPercent >= 66 ? 'bg-amber-400' : 'bg-red-400'"
            :style="{ width: completionPercent + '%' }"
          ></div>
        </div>
        <span class="text-white/70 text-xs flex-shrink-0">{{ pendingCount }} item(s) pendente(s)</span>
      </div>
      <button @click="dismiss('progress')" class="text-white/60 hover:text-white flex-shrink-0" title="Fechar">✕</button>
    </div>

    <!-- Sem localização (amber) -->
    <div
      v-if="store.needsLocation && !dismissed.location"
      class="bg-amber-100 border-b border-amber-300 text-amber-900 px-4 py-2 flex flex-wrap items-center justify-between gap-x-4 gap-y-1 text-sm"
    >
      <div class="flex items-center gap-2 flex-wrap">
        <span class="mdi mdi-map-marker-alert text-base flex-shrink-0"></span>
        <span>
          <strong>Você está invisível nas buscas!</strong>
          Seu endereço de atuação não está configurado — clientes próximos não conseguem te encontrar.
        </span>
        <router-link to="/perfil" class="font-semibold underline hover:no-underline">Configurar agora →</router-link>
      </div>
      <button @click="dismiss('location')" class="text-amber-700 hover:text-amber-950 flex-shrink-0" title="Fechar">✕</button>
    </div>

    <!-- Sem serviços (vermelho — não dismissível, é bloqueante para conversão) -->
    <div
      v-if="store.needsServices"
      class="bg-red-50 border-b border-red-300 text-red-800 px-4 py-2 flex flex-wrap items-center justify-between gap-x-4 gap-y-1 text-sm"
    >
      <div class="flex items-center gap-2 flex-wrap">
        <span class="mdi mdi-briefcase-alert text-base flex-shrink-0"></span>
        <span>
          <strong>Nenhum serviço ativo.</strong>
          Clientes que visitam seu perfil não conseguem agendar porque não há serviços disponíveis.
        </span>
        <router-link to="/meus-servicos" class="font-semibold underline hover:no-underline">Cadastrar serviço agora →</router-link>
      </div>
    </div>

    <!-- Sem disponibilidade (azul) -->
    <div
      v-if="store.needsSchedule && !dismissed.schedule"
      class="bg-blue-50 border-b border-blue-200 text-blue-800 px-4 py-2 flex flex-wrap items-center justify-between gap-x-4 gap-y-1 text-sm"
    >
      <div class="flex items-center gap-2 flex-wrap">
        <span class="mdi mdi-calendar-alert text-base flex-shrink-0"></span>
        <span>
          <strong>Agenda não configurada.</strong>
          Sem disponibilidade semanal, clientes não conseguem selecionar datas para agendar com você.
        </span>
        <router-link to="/minha-agenda" class="font-semibold underline hover:no-underline">Configurar agenda →</router-link>
      </div>
      <button @click="dismiss('schedule')" class="text-blue-600 hover:text-blue-900 flex-shrink-0" title="Fechar">✕</button>
    </div>
  </template>
</template>

<script setup>
import { reactive, computed } from 'vue'
import { useProviderOnboardingStore } from '@/store/providerOnboardingStore'

const store = useProviderOnboardingStore()

const dismissed = reactive({
  location: sessionStorage.getItem('banner_dismissed_location') === '1',
  schedule: sessionStorage.getItem('banner_dismissed_schedule') === '1',
  progress: sessionStorage.getItem('banner_dismissed_progress') === '1',
})

const pendingCount = computed(() => {
  let count = 0
  if (store.needsLocation) count++
  if (store.needsServices) count++
  if (store.needsSchedule) count++
  return count
})

const completionPercent = computed(() => {
  const total = 3
  const done = total - pendingCount.value
  return Math.round((done / total) * 100)
})

function dismiss (type) {
  dismissed[type] = true
  sessionStorage.setItem(`banner_dismissed_${type}`, '1')
}
</script>
